import { offerExtraGroupSchema, offerExtraGroupsSchema } from "./schema";
import { getEntity, getEntities } from "./base";

const path = "/portal/api/offer_extra_groups";

const getOfferExtraGroup = (clientConfig, entityId) => {
  return getEntity(clientConfig, entityId, path, offerExtraGroupSchema);
};

const getOfferExtraGroups = (clientConfig, dataStatus) => {
  let limits = { ...clientConfig.limits };
  limits.brandId = [];
  limits.dataSpeedGen = [];
  limits.phoneId = [];
  limits.phoneOperatingSystemId = [];
  limits.phoneVariantId = [];
  limits.providerId = [];

  return getEntities(
    clientConfig,
    dataStatus,
    path,
    offerExtraGroupsSchema,
    {},
    limits
  );
};

export { getOfferExtraGroup, getOfferExtraGroups };
